module.exports = "/images/vendor/desiigner-svg/svg/paypal.svg?0cf4ee9d645d4a3da6b822c203b65ffd";